import * as React from 'react';
import { Navigate } from 'react-router-dom';

const ACMOpenShift: React.FunctionComponent = () => (
  <Navigate to="/acm-openshift/edge-management/overview" replace />
);

export { ACMOpenShift };

